<template>
	<modal-box @close="onClose" header="Edit Staff">
		<div slot="buttons">
			<button @click="selectTab('staff')" :class="cssClass('staff')">Staff</button>
			<button @click="selectTab('permissions')" :class="cssClass('permissions')">Permissions</button>
			<button @click="selectTab('groups')" :class="cssClass('groups')">Groups</button>
		</div>
		<spinner v-if="loading"/>
		<form v-if="!loading" @submit.prevent="validateAndSubmit">
			<div v-show="isSelected('staff')">
				<input-text v-model="information.name" name="staff_name" placeholder="Name" rules="required"/>
				<input-text v-model="information.email" name="staff_email" placeholder="Email" rules="required|email"/>
				<input-radio-buttons v-model="information.type" :options="typeOptions" name="staff_type" placeholder="Type" rules="required"/>
				<input-radio-buttons v-model="information.status" :options="statusOptions" name="staff_status" placeholder="Status" rules="required"/>
			</div>
			<div v-show="isSelected('permissions')">
				<staff-staff-form-permissions :user_uid="user_uid" :permissions="findUserPermissions(user_uid)" @permissionsUpdate="onPermissionsUpdate"/>
			</div>
			<div v-show="isSelected('groups')">
				<staff-staff-form-group v-for="group in groups.data" :key="group.id" :group="group" :permissions="findGroupPermissions(group.id)" @groupPermissionsUpdate="onGroupPermissionsUpdate"/>
			</div>
			<div class="form-group-actions">
				<button-submit-icon-text :loading="form.loading" icon="save">{{ $t('buttons.general.save') }}</button-submit-icon-text>
			</div>
		</form>
	</modal-box>
</template>

<script>
import ApiObject from '@/classes/api/ApiObject'
import ApiCollection from '@/classes/api/ApiCollection'
import FormObject from '@/classes/api/FormObject'
import Staff from '@/classes/Staff'
import InputRadioButtons from './components/InputRadioButtons'
import StaffStaffFormGroup from './components/StaffStaffFormGroup'
import StaffStaffFormPermissions from './components/StaffStaffFormPermissions'
export default {
	components: {
		InputRadioButtons,
		StaffStaffFormGroup,
		StaffStaffFormPermissions
	},
	props: [
		'user_uid',
		'staff_id',
		'data'
	],
	data () {
		return {
			selectedTab: 'staff',
			staff: new ApiObject(),
			groups: new ApiCollection(),
			permissions: new ApiCollection(),
			form: new FormObject(),
			model: {},
			information: {
				name: '',
				email: '',
				type: '',
				status: true
			},
			typeOptions: [
				{ text: 'Staff', value: 'Staff' },
				{ text: 'Doctor', value: 'Doctor' }
			],
			statusOptions: [
				{ text: 'Enable', value: true },
				{ text: 'Disable', value: false }
			],
			separator: '|'
		}
	},
	computed: {
		loading () {
			return this.staff.loading || this.groups.loading || this.permissions.loading
		}
	},
	watch: {
		staff: {
			handler (value) {
				this.information.name = value.data.name || ''
				this.information.email = value.data.email || ''
				this.information.type = value.data.type || 'Staff'
				this.information.status = value.data.active || true
			},
			deep: true,
			immediate: true
		}
	},
	methods: {
		validateAndSubmit () {
			this.$validator.validateAll()
				.then(result => {
					if (result) this.editStaff()
				})
		},
		onClose () {
			this.$router.push({ name: 'UserProfileStaffStaff' })
		},
		onPermissionsUpdate (user_uid, permissions) {
			this.permissions.data = this.permissions.data.filter(ele => !(ele.element == 'user'))
			this.permissions.data.push({
				element: 'user',
				element_id: user_uid,
				permissions
			})
		},
		onGroupPermissionsUpdate (group_id, permissions) {
			this.permissions.data = this.permissions.data.filter(ele => !(ele.element == 'group' && ele.element_id == group_id))
			this.permissions.data.push({
				element: 'group',
				element_id: group_id,
				permissions
			})
		},
		selectTab (tabName) {
			this.selectedTab = tabName
		},
		isSelected (tabName) {
			return this.selectedTab === tabName
		},
		cssClass (tabName) {
			return this.isSelected(tabName) ? 'active' : ''
		},
		getStaff () {
			this.staff.loading = true
			this.staff.data = {}
			this.$api.staff.get(this, this.user_uid, this.staff_id)
				.then(response => {
					this.$log.info('staff form', 'api.staff.get OK', response)()
					this.staff.data = new Staff(response.body)
				}).catch(error => {
					this.$log.error('staff form', 'api.staff.get ERROR', error)()
					this.staff.error = error
				}).finally(() => {
					this.staff.loading = false
				})
		},
		getGroups () {
			this.groups.loading = true
			this.groups.data = []
			this.$api.groups.patients.getAll(this, this.user_uid)
				.then(response => {
					this.$log.info('staff form', 'groups.patients.getAll OK', response)()
					this.groups.data = response.body
				}).catch(error => {
					this.$log.error('staff form', 'groups.patients.getAll ERROR', error)()
					this.groups.error = error
				}).finally(() => {
					this.groups.loading = false
				})
		},
		getPermissions () {
			this.permissions.loading = true
			this.permissions.data = []
			this.$api.staff.permissions.getAll(this, this.user_uid, this.staff_id)
				.then(response => {
					this.$log.info('staff form', 'staff.permissions.getAll OK', response)()

					const map = new Map()

					response.body.forEach(token => {
						const permission = token.area.split(this.separator)

						/*if (permission.length == 2) {
							const element = permission[0]
							const area = permission[1]
							const key = `${element}`
							const value = {
								element,
								area
							}
							map.has(key) ? map.get(key).push(value) : map.set(key, [value])
						}*/

						if (permission.length == 3) {
							const element = permission[0]
							const id = permission[1]
							const area = permission[2]
							const key = `${element}_${id}`
							const value = {
								element,
								id,
								area
							}
							map.has(key) ? map.get(key).push(value) : map.set(key, [value])
						}
					})

					for (var [key, value] of map) {
						const obj = {}
						let element
						let element_id
						const list = []
						value.forEach(ele => {
							element = ele.element
							element_id = ele.id
							list.push(ele.area)
						})

						obj.element = element
						if (element_id)
							obj.element_id = element_id
						obj.permissions = list

						this.permissions.data.push(obj)
					}

				}).catch(error => {
					this.$log.error('staff form', 'staff.permissions.getAll ERROR', error)()
					this.permissions.error = error
				}).finally(() => {
					this.permissions.loading = false
				})
		},
		editStaff () {
			const permissions = []
			this.permissions.data.forEach(ele => {
				ele.permissions.forEach(area => {
					ele.element_id ? 
						permissions.push(`${ele.element}${this.separator}${ele.element_id}${this.separator}${area}`)
						:
						permissions.push(`${ele.element}${this.separator}${area}`)
				})
			})
			this.model = {
				information: this.information,
				permissions
			}
			this.form.loading = true
			this.$api.staff.edit(this, this.user_uid, this.staff_id, this.model)
				.then(response => {
					this.$log.info('staff form', 'api.staff.edit OK', response)()
					this.onClose()
				}).catch(error => {
					this.$log.error('staff form', 'api.staff.edit ERROR', error)()
					this.form.error = error
				}).finally(() => {
					this.form.loading = false
				})
		},
		findUserPermissions (user_uid) {
			const permissions =  this.permissions.data.find(ele => ele.element == 'user' && ele.element_id == user_uid)
			return permissions ? permissions.permissions : []
		},
		findGroupPermissions (group_id) {
			const permissions =  this.permissions.data.find(ele => ele.element == 'group' && ele.element_id == group_id)
			return permissions ? permissions.permissions : []
		}
	},
	mounted () {
		if (this.data === undefined) {
			this.getStaff()
		} else {
			this.staff.data = new Staff(this.data)
		}
		this.getGroups()
		this.getPermissions()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/user/profile/staff/StaffStaffForm.vue